import React from 'react';
import { InputBase } from '../inputs';
import { useFormContext, Controller } from 'react-hook-form';

const InputText = ({
  name,
  placeholder,
  className,
  minLength = 3,
  maxLength = 100,
  icon,
  label,
  isRequired = false,
  isDisabled = false,
  useError = true,
  customValidation,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const defaultValidationRule = {
    minLength: {
      value: minLength,
      message: 'El campo es demasiado corto',
    },
    maxLength: {
      value: maxLength,
      message: 'El campo es demasiado largo',
    },
  };

  const validationRules = customValidation || defaultValidationRule;

  if (isRequired) {
    validationRules.required = 'This field is required';
  }

  return (
    <div className={`form-group ${className}`}>
      <Controller
        name={name}
        key={name}
        control={control}
        defaultValue=''
        rules={validationRules}
        render={({ field }) => (
          <div>
            <InputBase
              type='text'
              field={field}
              errors={errors}
              name={name}
              placeholder={placeholder}
              icon={icon}
              label={label}
              isDisabled={isDisabled}
            />
            {useError && errors[name] && (
              <div className='d-flex align-items-center  error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>{' '}
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default InputText;
